import { Box, Checkbox, Tab, Modal, Tabs, InputAdornment, IconButton, DialogTitle, Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import { format } from "date-fns";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonTransactionPaginationTable from "../../../../common/components/CommonTable/CommonTransactionPaginationTable";
import CommonTransactionTable from "../../../../common/components/CommonTable/CommonTransactionTable";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import { useGetUserActions } from "../../../../common/components/Custom Hooks/useGetUserActions";
import RadioField from "../../../../common/components/FormFields/RadioField";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import { autoSearchCssdItemKit, deletecleaningwrappingItem } from "../../../services/commonservices/commonservices";
import { getStoreDropdown } from "../../../services/commonservices/commonservices";
import { ModalStyle } from "../../../../common/components/modalstyle/ModalStyle";
import { autoSearchCssdItemItem } from "../../../services/commonservices/commonservices";
import {
  fetchTransferCssdItemsKitListCSSDRe,
  fetchTransferCssdItemsList,
  saveTransferCssdItemsList,
  getWrapperTypeDropdown,
  getWrappingMethodDropdown,
  getBatchWiseCssdKits,
} from "../../../services/transferReceiveCssdServices/TransferReceiveCssdServices";
import SearchBar from "../../../../common/components/FormFields/SearchBar";
import DatePickerField from "../../../../common/components/FormFields/DatePickerField";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import TableDropDownField from "../../../../common/components/FormFields/TableDropDownField";
import { UseCheckConsecutiveCharacters } from "../../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import { Autocomplete, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DeleteIcon } from "../../../../assets/CommonAssets";

const itemType = [
  { label: "Kit", value: "Kit", id: "Kit" },
  { label: "Item", value: "Item", id: "Item" },
];

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const WrappingAndPackaging = (props) => {
  const { setView } = props;
  const location = useLocation();
  const getUserInfo = JSON.parse(localStorage?.getItem("loggedUser"));
  const [packagingItemList, setPackagingItemList] = useState([]);
  const [packagingKitList, setPackagingKitList] = useState([]);
  const [packagingKitItemsList, setPackagingKitItemsList] = useState([]);
  const [modalItemItemOptions, setModalItemItemOptions] = useState([]);
  const [modalItemKitOptions, setModalItemKitOptions] = useState([]);
  const [groupedItems, setGroupedItems] = useState({});
  const [manualUpdate, setManualUpdate] = useState(false);
  const [finalTabs, setFinalTabs] = useState([]);

  const [page, setPage] = useState(0);
  const [kitPage, setKitPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [kitRowsPerPage, setKitRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);
  const [kitCount, setKitCount] = useState(null);
  const [openKitModal, setOpenAddKitModal] = useState(false);
  const [openPostModal, setOpenPostModal] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [userActions, setUserActions] = useState([]);
  const [itemKitOptions, setItemKitOptions] = useState([]);
  const [cleaningItemsList, setCleaningItemsList] = useState([]);
  const [cleaningKitItemsList, setCleaningKitItemsList] = useState([]);
  const [selectedWrappingMethodId, setSelectedWrappingMethodId] = useState(0);
  const [selectedWrapperTypeId, setSelectedWrapperTypeId] = useState(null);
  const [selectedKit, setSelectedKit] = useState(null);
  const { getValues, reset } = useForm();
  const [addType, setAddType] = useState("kit"); // "kit" or "item"
  const [cleaningKitList, setCleaningKitList] = useState([]);

  const [openModel, setOpenModel] = useState(false);
  const [pendingRow, setPendingRow] = useState(null);
  const [kitListingObject, setKitListingObject] = useState({
    searchString: "",
    searchId: null,
    fromDate: null,
    toDate: null,
    page: page,
    size: rowsPerPage,
  });
  const [storeOptions, setStoreOptions] = useState([]);
  const [wrapperTypeOptions, setWrapperTypeOptions] = useState([]);
  const [wrappingMethodOptions, setWrappingMethodOptions] = useState([]);
  const [values, setValues] = useState(null);
  const [searchBarId, setSearchBarId] = useState(null);
  const [searchBarString, setSearchBarString] = useState("");
  const [selectedWrappingType, setSelectedWrappingType] = useState("");
  const [selectedWrappingMethod, setSelectedWrappingMethod] = useState("");
  const [wrapperTypeInput, setWrapperTypeInput] = useState("");
  const [existKitBatch, setExistKitBatch] = useState("");
  const [newKitBatch, setNewKitBatch] = useState("");

  // const [wrappingTypeOptions, setWrappingTypeOptions] = useState([]);
  // const [wrappingMethodOptions, setWrappingMethodOptions] = useState([]);

  const [loadingWrappingType, setLoadingWrappingType] = useState(false);
  const [loadingWrappingMethod, setLoadingWrappingMethod] = useState(false);


  const handleChange = (event, newValue) => {
    setValues(newValue);
  };

  console.log("newKitBatch", newKitBatch, "existKitBatch", existKitBatch);

  const handleAdd = () => {

    if (!selectedKit) return warningAlert("Please select a target kit!");

    if (!getAddKitItemSearch?.id) return warningAlert("Select item!");

    const itemId = getAddKitItemSearch?.id;

    const exists = groupedItems[selectedKit]?.some(
      item => item["Item Code"] === itemId
    );

    if (exists) return warningAlert("Item already exists in this kit!");

    setGroupedItems(prev => ({
      ...prev,
      [selectedKit]: [
        ...prev[selectedKit],
        {
          "Item Code": itemId,
          "Item Name": getAddKitItemSearch?.label,
        }
      ]
    }));

    setValue("addKitItemSearch", null);
    setSelectedKit(null);
    setOpenAddKitModal(false);
  };


  const handleAddKitItemChange = (autoSearchString, actionMeta) => {

    if (!autoSearchString) return autoSearchString; // must return something

    if (addType === "kit") {
      autoSearchCssdItemKit(autoSearchString, "cssd")
        .then((res) => setModalItemKitOptions(res.data.result));
    } else {
      autoSearchCssdItemItem(autoSearchString, "cssd")
        .then((res) => setModalItemItemOptions(res.data.result));
    }

    return autoSearchString; // IMPORTANT → needed by react-select
  };


  const handleCancelDelete = () => {
    setFinalTabs(prev =>
      prev.map((kit, kitIndex) =>
        kitIndex !== values
          ? kit
          : {
            ...kit,
            items: kit.items.map(item =>
              item.pendingDelete
                ? { ...item, pendingDelete: false }
                : item
            ),
          }
      )
    );

    setPendingRow(null);
    setOpenModel(false);
  };

  const handleConfirmDelete = async (e) => {
    e?.preventDefault();
    if (!pendingRow) return;

    try {
      const res = await deletecleaningwrappingItem(pendingRow.id);

      if (res?.status === 200) {
        setGroupedItems(prev => {
          const newState = { ...prev };

          Object.keys(newState).forEach(kitId => {
            newState[kitId] = newState[kitId].filter(
              item => Number(item.id) !== Number(pendingRow.id)
            );
          });

          return newState;
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setPendingRow(null);
      setOpenModel(false);
    }
  };

  const handleDeleteClick = (row) => {
    setFinalTabs(prev =>
      prev.map((kit, kitIndex) =>
        kitIndex !== values
          ? kit
          : {
            ...kit,
            items: kit.items.map(item =>
              item.id === row.id
                ? { ...item, pendingDelete: true } // ✅ SAME DATA
                : item
            ),
          }
      )
    );

    setPendingRow(row);
    setOpenModel(true);
  };

  const handleReceiveCSSDSearch = async () => {
    try {
      const payload = {
        searchString: watch("searchByItem") || null,
        page: kitPage,
        size: kitRowsPerPage,
        fromDate: format(getFromDate, "yyyy-MM-dd"),
        toDate: format(getToDate, "yyyy-MM-dd"),
        searchId: null,
        processType: "wrapping",
        storeId: watch("fromStore")?.value ?? null
      };

      console.log("wrapping Payload:", payload);

      const res = await fetchTransferCssdItemsKitListCSSDRe(payload);

      const tableData = (res?.data?.result || []).map(item => ({
        Select: false,
        ...item
      }));

      setPackagingKitList(tableData);

    } catch (error) {
      console.error("wrapping API Error:", error);
    }
  };

  const defaultValues = {
    fromDate: null,
    toDate: null,
    itemType: "Kit",
    fromStore: null,
  };
  const {
    control,
    watch,
    setError,
    clearErrors,
    setValue,
    register,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
  });

  let getFromDate = watch("fromDate");
  let getToDate = watch("toDate");
  let getItemType = watch("itemType");
  let getStore = watch("fromStore");

  let getAddKitItemSearch = watch("addKitItemSearch");

  const populateItemTable = (forPagination) => {
    let listObj = {
      searchString: "",
      searchId: null,
      fromDate: null,
      toDate: null,
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
      processType: "wrapping",
      kitId: null,
    };
    fetchTransferCssdItemsList(listObj.id, listObj.kitBatchNo).then((response) => {
      if (forPagination) {
        setPackagingItemList((prevData) => [
          ...prevData,
          ...response.data.result?.map((val) => ({
            Select: true,
            "id": val?.["id"],
            "Item Code": val?.["Item Code"],
            "Item Name": val?.["Item Name"],
            ...val,
            "Wrapped Qty": val?.["Cleaned Qty"],
            "Old Wrapped Qty": val?.["Cleaned Qty"],
            "Wrapper Type": val?.["Wrapper Type"],
            "Wrapper Type Qty": val?.["Wrapper Type Qty"],
            "Wrapping Method": val?.["Wrapping Method"],
          })),
        ]);
      } else {
        setPackagingItemList(
          response.data.result?.map((val) => ({
            Select: true,
            "Item Code": val?.["Item Code"],
            "Item Name": val?.["Item Name"],
            ...val,
            "Wrapped Qty": val?.["Cleaned Qty"],
            "Old Wrapped Qty": val?.["Cleaned Qty"],
            "Wrapper Type": val?.["Wrapper Type"],
            "Wrapper Type Qty": val?.["Wrapper Type Qty"],
            "Wrapping Method": val?.["Wrapping Method"],
          }))
        );
        setPage(0);
      }
      setCount(response.data.count);
    });
  };

  const populateKitTable = (forPagination) => {
    let listObj = {
      searchString: kitListingObject?.searchString,
      searchId: kitListingObject?.searchId,
      fromDate: kitListingObject?.fromDate,
      toDate: kitListingObject?.toDate,
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
      processType: "wrapping",
    };
    fetchTransferCssdItemsKitListCSSDRe(listObj).then((response) => {
      if (forPagination) {
        setPackagingKitList((prevData) => [
          ...prevData,
          ...response?.data?.result?.map((val) => ({
            Select: false,
            ...val,

            "Wrapper Type": val?.["Wrapper Type"],
            "Wrapper Type Qty": val?.["Wrapper Type Qty"],
            "Wrapping Method": val?.["Wrapping Method"],

          })),
        ]);
      } else {
        setPackagingKitList(
          response.data.result?.map((val) => ({
            Select: false,
            ...val,

            "Wrapper Type": val?.["Wrapper Type"],
            "Wrapper Type Qty": val?.["Wrapper Type Qty"],
            "Wrapping Method": val?.["Wrapping Method"],

          }))
        );
        setKitPage(0);
      }
      setKitCount(response.data.count);
    });
  };

  const populateKitItemTable = (id, kitBatchNo, KitName, kitId, kitName, srNo) => {
    let listObj = {
      searchString: "",
      searchId: null,
      fromDate: null,
      toDate: null,
      processType: "wrapping",
      kitId: kitId,
      page: null,
      size: null,
    };
    // fetchTransferCssdItemsList(id, kitBatchNo, KitName).then((response) => {
    //   let newItems =
    //     response?.data?.statusCode === 200
    //       ? response?.data?.result?.map((val) => ({
    //         Select: true,
    //         "id": val?.["id"],
    //         "Item Code": val?.["item_id"],
    //         "Item Name": val?.["ItemName"],
    //         "KidId": val?.["item_kit_id"],
    //         "Kit Name": val?.["KitName"],
    //         "Cleaned Qty": val?.["cleanedQty"],
    //         "Wrapped Qty": val?.["wrappedQty"],
    //         "Old Wrapped Qty": val?.["Cleaned Qty"],
    //       }))
    //       : [];
    //   let kitObj = {
    //     id,
    //     kitBatchNo,
    //     KitName,
    //     kitItemList: newItems?.length > 0 ? newItems : [],
    //   };
    //   setPackagingKitItemsList((prevData) => [...prevData, { ...kitObj }]);
    // });

    const groupedKits = Object.values(
      cleaningKitItemsList.reduce((acc, item) => {
        const kitId = item.kitId || 0;

        if (!acc[kitId]) {
          acc[kitId] = {
            kitId,
            KitName: item.KitName || `Kit ${kitId}`,
            kitItemList: []
          };
        }

        acc[kitId].kitItemList.push(item);
        return acc;
      }, {})
    );

    fetchTransferCssdItemsList(id, kitBatchNo, KitName).then((response) => {
      console.log("kitResponse", response);

      let newItems =
        response?.data?.statusCode === 200
          ? response?.data?.result?.map((val) => ({
            Select: true,
            Delete: "",
            // pass: val?.pass ?? 1,
            id: val?.id,
            "Item Code": val?.item_id,
            "Item Name": val?.ItemName,
            // kitId: val?.item_kit_id,    // FIX: "kidId" → "kitId"
            kitId: val?.kitId ?? val?.item_kit_id ?? 0,
            "KitName": val?.KitName,
            "Cleaned Qty": val?.["cleanedQty"],
            "Wrapped Qty": val?.["cleanedQty"],
            "Wrapper Type": val?.["Wrapper Type"],
            "Wrapping Method": val?.["wrappingMethod"],
          }))
          : [];

      const kitObj = {
        id,
        kitBatchNo,
        KitName,
        kitItemList: newItems?.length > 0 ? newItems : [],
      };

      setPackagingKitItemsList((prevData) => [...prevData, kitObj]);
    });
  };

  const renderInputItem = (row, index, header) => {
    if (row?.["Wrapper Type Id"] && row?.["Wrapper Type"]) {
      setValue(`wrapperType${row?.["Sr No"]}`, {
        value: row?.["Wrapper Type Id"],
        label: row?.["Wrapper Type"],
      });
    }
    if (row?.["Wrapping Method Id"] && row?.["Wrapping Method"]) {
      setValue(`wrappingMethod${row?.["Sr No"]}`, {
        value: row?.["Wrapping Method Id"],
        label: row?.["Wrapping Method"],
      });
    }
    return (
      <div className="-my-2">
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`Select${row?.["Sr No"]}`}
            checked={row?.Select}
            onChange={(e) => {
              setPackagingItemList((prevTransferItemList) =>
                prevTransferItemList.map((val, i) =>
                  val?.["Item Code"] === row?.["Item Code"] &&
                    val?.["Sr No"] === row?.["Sr No"]
                    ? { ...val, Select: e.target.checked }
                    : val
                )
              );
            }}
          />
        )}
        {header === "Wrapped Qty" && (
          <input
            type="number"
            name={`wrappedQty${row?.["Sr No"]}`}
            value={row?.["Wrapped Qty"]}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              if (e.target.value <= Number(row?.["Old Wrapped Qty"])) {
                setPackagingItemList((prevTransferItemList) =>
                  prevTransferItemList.map((val, i) =>
                    val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? {
                        ...val,
                        ["Wrapped Qty"]:
                          e.target.value !== ""
                            ? e.target.value
                            : val?.["Old Wrapped Qty"],
                      }
                      : val
                  )
                );
              }
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}
        {header === "Wrapper Type" && (
          <TableDropDownField
            control={control}
            name={`wrapperType${row?.["Sr No"]}`}
            dataArray={wrapperTypeOptions}
            isClearable={true}
            isDisabled={row?.Select !== true}
            menuPlacement="bottom"
            inputRef={{
              ...register(`wrapperType${row?.["Sr No"]}`, {
                onChange: (e) => {
                  setPackagingItemList((prevTransferItemList) =>
                    prevTransferItemList.map((val, i) =>
                      val?.["Item Code"] === row?.["Item Code"] &&
                        val?.["Sr No"] === row?.["Sr No"]
                        ? {
                          ...val,
                          ["Wrapper Type Id"]: e.target.value?.id,
                          ["Wrapper Type"]: e.target.value?.label,
                        }
                        : val
                    )
                  );
                },
              }),
            }}
          />
        )}
        {header === "Wrapper Type Qty" && (
          <input
            type="number"
            name={`wrapperTypeQty${row?.["Sr No"]}`}
            value={row?.["Wrapper Type Qty"]}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              setPackagingItemList((prevTransferItemList) =>
                prevTransferItemList.map((val, i) =>
                  val?.["Item Code"] === row?.["Item Code"] &&
                    val?.["Sr No"] === row?.["Sr No"]
                    ? { ...val, ["Wrapper Type Qty"]: e.target.value }
                    : val
                )
              );
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}
        {header === "Wrapping Method" && (
          <TableDropDownField
            control={control}
            name={`wrappingMethod${row?.["Sr No"]}`}
            dataArray={wrappingMethodOptions}
            isClearable={true}
            isDisabled={row?.Select !== true}
            menuPlacement="bottom"
            inputRef={{
              ...register(`wrappingMethod${row?.["Sr No"]}`, {
                onChange: (e) => {
                  setPackagingItemList((prevTransferItemList) =>
                    prevTransferItemList.map((val, i) =>
                      val?.["Item Code"] === row?.["Item Code"] &&
                        val?.["Sr No"] === row?.["Sr No"]
                        ? {
                          ...val,
                          ["Wrapping Method Id"]: e.target.value?.id,
                          ["Wrapping Method"]: e.target.value?.label,
                        }
                        : val
                    )
                  );
                },
              }),
            }}
          />
        )}
      </div>
    );
  };

  // const renderInputKit = (row, index, header) => {
  //   if (row?.["Wrapper Type Id"] && row?.["Wrapper Type"]) {
  //     setValue(`wrappperType${row?.["Sr No"]}`, {
  //       value: row?.["Wrapper Type Id"],
  //       label: row?.["Wrapper Type"],
  //     });
  //   }
  //   if (row?.["Wrapping Method Id"] && row?.["Wrapping Method"]) {
  //     setValue(`wrappingMethod${row?.["Sr No"]}`, {
  //       value: row?.["Wrapping Method Id"],
  //       label: row?.["Wrapping Method"],
  //     });
  //   }
  //   return (
  //     <div className="-my-2">
  //       {header === "Select" && (
  //         <Checkbox
  //           size="small"
  //           name={`SelectKit${row?.["Sr No"]}`}
  //           checked={row?.Select}
  //           onChange={(e) => {
  //             setPackagingKitList((prevData) =>
  //               prevData?.map((kit) => ({
  //                 ...kit,
  //                 Select:
  //                   kit?.["Item Kit Code"] === row?.["Item Kit Code"] &&
  //                     kit?.["Sr No"] === row?.["Sr No"]
  //                     ? e.target.checked
  //                     : kit?.Select,
  //               }))
  //             );
  //             if (e.target.checked) {
  //               if (packagingKitItemsList?.length === 0) {
  //                 setValues(0);
  //               }
  //               populateKitItemTable(

  //                 row?.id,
  //                 row?.kitBatchNo,
  //                 row?.KitName
  //               );
  //             } else {
  //               setPackagingKitItemsList(
  //                 packagingKitItemsList?.filter(
  //                   (val) => val?.srNo !== row?.["Sr No"]
  //                 )
  //               );
  //             }
  //             // setPackagingKitList((prevTransferItemList) =>
  //             //   prevTransferItemList.map((val, i) =>
  //             //     index === i ? { ...val, Select: e.target.checked } : val
  //             //   )
  //             // );
  //           }}
  //         />
  //       )}
  //       {header === "Wrapper Type" && (
  //         <TableDropDownField
  //           control={control}
  //           name={`wrappperType${row?.["Sr No"]}`}
  //           dataArray={wrapperTypeOptions}
  //           isClearable={true}
  //           isDisabled={row?.Select !== true}
  //           menuPlacement="bottom"
  //           inputRef={{
  //             ...register(`wrappperType${row?.["Sr No"]}`, {
  //               onChange: (e) => {
  //                 setPackagingKitList((prevKitList) =>
  //                   prevKitList.map((val) =>
  //                     val?.["Item Kit Code"] === row?.["Item Kit Code"] &&
  //                       val?.["Sr No"] === row?.["Sr No"]
  //                       ? {
  //                         ...val,
  //                         ["Wrapper Type Id"]: e.target.value?.id,
  //                         ["Wrapper Type"]: e.target.value?.label,
  //                       }
  //                       : val
  //                   )
  //                 );
  //                 setPackagingKitItemsList((prevKitItemsList) =>
  //                   prevKitItemsList.map((kit) => ({
  //                     ...kit,
  //                     kitItemList:
  //                       kit.kitItemList && row?.["Sr No"] === kit.srNo // assuming kit has an itemKitName field
  //                         ? kit.kitItemList.map((val) => ({
  //                           ...val,
  //                           ["Wrapper Type Id"]: e.target.value?.id,
  //                           ["Wrapper Type"]: e.target.value?.label,
  //                         }))
  //                         : kit.kitItemList,
  //                   }))
  //                 );
  //               },
  //             }),
  //           }}
  //         />
  //       )}
  //       {header === "Wrapping Method" && (
  //         <TableDropDownField
  //           control={control}
  //           name={`wrappingMethod${row?.["Sr No"]}`}
  //           dataArray={wrappingMethodOptions}
  //           isClearable={true}
  //           isDisabled={row?.Select !== true}
  //           menuPlacement="bottom"
  //           inputRef={{
  //             ...register(`wrappingMethod${row?.["Sr No"]}`, {
  //               onChange: (e) => {
  //                 setPackagingKitList((prevKitList) =>
  //                   prevKitList.map((val) =>
  //                     val?.["Item Kit Code"] === row?.["Item Kit Code"] &&
  //                       val?.["Sr No"] === row?.["Sr No"]
  //                       ? {
  //                         ...val,
  //                         ["Wrapping Method Id"]: e.target.value?.id,
  //                         ["Wrapping Method"]: e.target.value?.label,
  //                       }
  //                       : val
  //                   )
  //                 );
  //                 setPackagingKitItemsList((prevKitItemsList) =>
  //                   prevKitItemsList.map((kit) => ({
  //                     ...kit,
  //                     kitItemList:
  //                       kit.kitItemList && row?.["Sr No"] === kit.srNo // assuming kit has an itemKitName field
  //                         ? kit.kitItemList.map((val) => ({
  //                           ...val,
  //                           ["Wrapping Method Id"]: e.target.value?.id,
  //                           ["Wrapping Method"]: e.target.value?.label,
  //                         }))
  //                         : kit.kitItemList,
  //                   }))
  //                 );
  //               },
  //             }),
  //           }}
  //         />
  //       )}
  //       {header === "Wrapper Type Qty" && (
  //         <input
  //           type="number"
  //           name={`wrapperTypeQty${row?.["Sr No"]}`}
  //           value={row?.["Wrapper Type Qty"]}
  //           className="border border-black rounded w-28 px-2"
  //           disabled={row?.Select !== true}
  //           onChange={(e) => {
  //             setPackagingKitList((prevKitList) =>
  //               prevKitList.map((val) =>
  //                 val?.["Item Kit Code"] === row?.["Item Kit Code"] &&
  //                   val?.["Sr No"] === row?.["Sr No"]
  //                   ? {
  //                     ...val,
  //                     ["Wrapper Type Qty"]: e.target.value,
  //                   }
  //                   : val
  //               )
  //             );
  //             setPackagingKitItemsList((prevKitItemsList) =>
  //               prevKitItemsList.map((kit) => ({
  //                 ...kit,
  //                 kitItemList:
  //                   kit.kitItemList && row?.["Sr No"] === kit.srNo // assuming kit has an itemKitName field
  //                     ? kit.kitItemList.map((val) => ({
  //                       ...val,
  //                       ["Wrapper Type Qty"]: e.target.value,
  //                     }))
  //                     : kit.kitItemList,
  //               }))
  //             );
  //           }}
  //           onWheel={(e) => e.target.blur()}
  //           onKeyDown={(e) =>
  //             ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
  //               e.key
  //             ) && e.preventDefault()
  //           }
  //         />
  //       )}
  //     </div>
  //   );
  // };

  const [selectedKitRows, setSelectedKitRows] = useState({});

  const renderInputKit = (row, index, header) => {
    return (
      <div className="-my-2">

        {/* SELECT CHECKBOX */}
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`SelectKit${row?.id}`}
            checked={!!selectedKitRows[row.id]}
            onChange={(e) => {
              const isChecked = e.target.checked;

              // 1️⃣ Update selection state
              setSelectedKitRows((prev) => ({
                ...prev,
                [row.id]: isChecked,
              }));

              // 2️⃣ Update main kit list
              setPackagingKitList((prev) =>
                prev.map((kit) =>
                  kit.id === row.id ? { ...kit, Select: isChecked } : kit
                )
              );

              // 3️⃣ Add OR Remove from kit item list
              if (isChecked) {
                // Set first tab index
                if (packagingKitItemsList.length === 0) {
                  setValues(0);
                }

                // Load kit items
                populateKitItemTable(row.id, row.kitBatchNo, row.KitName);
              } else {
                // Remove kit items of this kit
                setCleaningKitItemsList((prev) =>
                  prev.filter((kit) => kit.id !== row.id)
                );
              }
            }}
          />
        )}
      </div>
    );
  };

  // const renderInputKitItem = (row, index, header) => {
  //   return (
  //     <div className="-my-2">
  //       {/* {header === "Select" && (
  //         <Checkbox
  //           size="small"
  //           name={`${values}SelectKitItem${index}`}
  //           checked={row?.Select}
  //           onChange={(e) => {
  //             setPackagingKitItemsList((prevDataObj) =>
  //               prevDataObj?.map((kit, kitInd) => ({
  //                 ...kit,
  //                 kitItemList: kit.kitItemList?.map((val) =>
  //                   values === kitInd &&
  //                   val?.["Item Code"] === row?.["Item Code"] &&
  //                   val?.["Sr No"] === row?.["Sr No"]
  //                     ? { ...val, Select: e.target.checked }
  //                     : val
  //                 ),
  //               }))
  //             );
  //           }}
  //         />
  //       )} */}
  //       {header === "Wrapped Qty" && (
  //         <input
  //           type="number"
  //           name={`${values}wrappedQty${index}`}
  //           value={row?.["Wrapped Qty"]}
  //           className="border border-black rounded w-28 px-2"
  //           onChange={(e) => {
  //             if (e.target.value <= Number(row?.["Old Wrapped Qty"])) {
  //               setPackagingKitItemsList((prevDataObj) =>
  //                 prevDataObj?.map((kit, kitInd) => ({
  //                   ...kit,
  //                   kitItemList: kit.kitItemList?.map((val) =>
  //                     values === kitInd &&
  //                       val?.["Item Code"] === row?.["Item Code"] &&
  //                       val?.["Sr No"] === row?.["Sr No"]
  //                       ? {
  //                         ...val,
  //                         "Wrapped Qty":
  //                           e.target.value !== ""
  //                             ? e.target.value
  //                             : val?.["Old Wrapped Qty"],
  //                       }
  //                       : val
  //                   ),
  //                 }))
  //               );
  //             }
  //           }}
  //           onWheel={(e) => e.target.blur()}
  //           onKeyDown={(e) =>
  //             ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
  //               e.key
  //             ) && e.preventDefault()
  //           }
  //         />
  //       )}
  //     </div>
  //   );
  // };

  // const addToStockList = () => {
  //   let itemDetailsArray =
  //     getItemType === "Item"
  //       ? packagingItemList
  //       : packagingKitItemsList
  //         ?.flatMap((val) => val?.kitItemList)
  //         ?.filter((fil) => fil.Select === true);
  //   let postObject = {
  //     id: null,
  //     fromStore: getUserInfo?.loginStoreId,
  //     toStore: getUserInfo?.loginStoreId,
  //     itemDetailsRequestDtoList: itemDetailsArray
  //       ?.filter((val) => val?.Select === true)
  //       ?.map((item) => ({
  //         id: item?.Id,
  //         cssdTransferId: item?.["Cssd Transfer Id"]
  //           ? item?.["Cssd Transfer Id"]
  //           : null,
  //         otDetails:
  //           item?.["Ot Details Id"] !== null
  //             ? {
  //               id: item?.["Ot Details Id"],
  //             }
  //             : null,
  //         item:
  //           item?.["Item Id"] !== null
  //             ? {
  //               id: item?.["Item Id"],
  //             }
  //             : null,
  //         itemKit:
  //           item?.["Item Kit Code"] !== null
  //             ? {
  //               id: item?.["Item Kit Code"],
  //             }
  //             : null,
  //         transferDate:
  //           item?.["Transfer Date"] !== null
  //             ? item?.["Transfer Date"]?.replace(" ", "T")?.split(".")[0]
  //             : null,
  //         transferQty: item?.["Transfer Qty"]
  //           ? Number(item?.["Transfer Qty"])
  //           : null,
  //         transferStatus: item?.["Transfer Status"],
  //         transferredBy:
  //           item?.["Transferred By"] !== null
  //             ? { id: item?.["Transferred By"] }
  //             : null,

  //         issueDate:
  //           item?.["Issue Date"] !== null
  //             ? item?.["Issue Date"]?.replace(" ", "T")
  //             : null,
  //         issueStatus: item?.["Issue Status"],
  //         issueQty:
  //           item?.["Issue Qty"] !== null ? Number(item?.["Issue Qty"]) : null,
  //         issuedBy:
  //           item?.["Issued By"] !== null ? { id: item?.["Issued By"] } : null,

  //         disposedDate:
  //           item?.["Disposed Date"] !== null
  //             ? item?.["Disposed Date"]?.replace(" ", "T")
  //             : null,
  //         disposedQty: item?.["Disposed Qty"]
  //           ? Number(item?.["Disposed Qty"])
  //           : null,
  //         disposedBy:
  //           item?.["Disposed By"] !== null
  //             ? { id: item?.["Disposed By"] }
  //             : null,

  //         receiveDate:
  //           item?.["Receive Date"] !== null
  //             ? item?.["Receive Date"]?.replace(" ", "T")
  //             : null,
  //         receiveQty: item?.["Receive Qty"]
  //           ? Number(item?.["Receive Qty"])
  //           : null,
  //         receiveStatus: item?.["Receive Status"],
  //         receivedBy: item?.["Received By"]
  //           ? { id: item?.["Received By"] }
  //           : null,

  //         cleaningStatus: item?.["Cleaning Status"],
  //         cleanedQty:
  //           item?.["Cleaned Qty"] !== null
  //             ? Number(item?.["Cleaned Qty"])
  //             : null,
  //         cleaningStartDate:
  //           item?.["Cleaning Start Date"] !== null
  //             ? item?.["Cleaning Start Date"]?.replace(" ", "T")
  //             : null,
  //         cleaningEndDate:
  //           item?.["Cleaning End Date"] !== null
  //             ? item?.["Cleaning End Date"]?.replace(" ", "T")
  //             : null,
  //         cleanedBy:
  //           item?.["Cleaned By"] !== null ? { id: item?.["Cleaned By"] } : null,

  //         wrappedQty:
  //           item?.["Wrapped Qty"] !== null
  //             ? Number(item?.["Wrapped Qty"])
  //             : null,
  //         wrappingStatus: true,
  //         wrappedBy: { id: getUserInfo?.employeeId },
  //         wrapperType:
  //           item?.["Wrapper Type Id"] !== null
  //             ? { id: item?.["Wrapper Type Id"] }
  //             : null,
  //         wrapperTypeQty:
  //           item?.["Wrapper Type Qty"] !== null
  //             ? item?.["Wrapper Type Qty"]
  //             : null,
  //         wrappingMethod:
  //           item?.["Wrapping Method Id"] !== null
  //             ? { id: item?.["Wrapping Method Id"] }
  //             : null,
  //         wrappingStartDate:
  //           item?.["Wrapping Start Date"] !== null
  //             ? item?.["Wrapping Start Date"]?.replace(" ", "T")
  //             : null,
  //         wrappingEndDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),

  //         sterilizationQty:
  //           item?.["Sterilization Qty"] !== null
  //             ? Number(item?.["Sterilization Qty"])
  //             : null,
  //         sterilizationStatus: item?.["Sterilization Status"],
  //         sterilizationStatusType: item?.["Sterilization Status Type"],
  //         sterilizationStartBy:
  //           item?.["Sterilization Start By"] !== null
  //             ? { id: item?.["Sterilization Start By"] }
  //             : null,
  //         sterilizationEndBy:
  //           item?.["Sterilization End By"] !== null
  //             ? { id: item?.["Sterilization End By"] }
  //             : null,
  //         sterilizationStartDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
  //         sterilizationEndDate:
  //           item?.["Sterilization End Date"] !== null
  //             ? item?.["Sterilization End Date"]?.replace(" ", "T")
  //             : null,
  //         sterilizationType:
  //           item?.["Sterilization Equipment Id"] !== null
  //             ? { id: item?.["Sterilization Equipment Id"] }
  //             : null,
  //         sterilizationMethod:
  //           item?.["Sterilization Method Id"] !== null
  //             ? { id: item?.["Sterilization Method Id"] }
  //             : null,
  //         sterilizationExpiryDate:
  //           item?.["Sterilization ExpiryDate"] !== null
  //             ? item?.["Sterilization ExpiryDate"]?.replace(" ", "T")
  //             : null,

  //         addToStockQty:
  //           item?.["AddToStock Qty"] !== null
  //             ? Number(item?.["AddToStock Qty"])
  //             : null,

  //         decontaminationStatus: item?.["Decontamination Status"],

  //         kitBatchNo: item?.["kitBatchNo"],
  //         itemBatchNo: item?.["Item BatchNo"],
  //         processType: "wrapping",
  //       })),
  //   };
  //   console.log("postObject", postObject);
  //   setOpenPostModal(false);
  //   setOpenBackdrop(true);
  //   saveTransferCssdItemsList(postObject)
  //     .then((response) => {
  //       successAlert(response.data.message);
  //       setOpenPostModal(false);
  //       populateItemTable();
  //       setOpenBackdrop(false);
  //       setView("Sterilization Processing");
  //     })
  //     .catch((error) => {
  //       errorAlert(error.message);
  //       setOpenBackdrop(false);
  //     });
  // };


  // const addToStockList = async () => {
  //   setOpenBackdrop(true); // Show loading

  //   try {
  //     // 🔹 Always take all items, default to empty array if undefined
  //     const itemDetailsArray =
  //       getItemType === "Item"
  //         ? cleaningItemsList || []
  //         : cleaningKitItemsList?.flatMap((kit) => kit.kitItemList) || [];

  //     // 🔹 Prepare payload for Wrapping (even if array is empty)
  //     const payload = itemDetailsArray.map((item) => ({
  //       id: item?.id || 0,
  //       processType: "wrapping",
  //       ot_details_id: 0,
  //       item_id: item?.["Item Code"] || 0,
  //       item_kit_id: 0,
  //       quantity: 0,
  //       transferDate: new Date().toISOString(),
  //       transferQty: 0,
  //       transferStatus: true,
  //       transferred_by: 0,
  //       issueDate: new Date().toISOString(),
  //       issueStatus: true,
  //       issueQty: 0,
  //       issued_by: 0,
  //       disposedDate: new Date().toISOString(),
  //       disposedQty: item?.["Disposed Qty"] || 0,
  //       disposed_by: 0,
  //       disposedReason: item?.["Disposed Reason"] || null,
  //       receiveDate: new Date().toISOString(),
  //       receiveQty: 0,
  //       receiveStatus: true,
  //       received_by: 0,
  //       cleaningStatus: true,
  //       decontaminationStatus: true,
  //       cleanedQty: item?.["Cleaned Qty"] || 0,
  //       cleaned_by: 0,
  //       cleaningStartDate: new Date().toISOString(),
  //       cleaningEndDate: new Date().toISOString(),
  //       wrappedQty: 0,
  //       wrappingStatus: true,
  //       wrapped_by: 0,
  //       wrapper_type_id: 0,
  //       wrapperTypeQty: 0,
  //       wrapping_method_id: 0,
  //       wrappingStartDate: new Date().toISOString(),
  //       wrappingEndDate: new Date().toISOString(),
  //       sterilizationQty: 0,
  //       sterilizationStatus: true,
  //       sterilizationStatusType: "wrapping",
  //       sterilization_start_by: 0,
  //       sterilizationStartDate: new Date().toISOString(),
  //       sterilizationEndDate: new Date().toISOString(),
  //       sterilization_end_by: 0,
  //       machine_id: 0,
  //       sterilization_type_id: 0,
  //       sterilization_method: 0,
  //       sterilizationExpiryDate: new Date().toISOString(),
  //       addToStockQty: 0,
  //       temperature: 0,
  //       pressure: 0,
  //       durationMinutes: 0,
  //       indicatorResult: "string",
  //       from_store_id: 0,
  //       to_store_id: 0,
  //       itemBatchNo: item?.["Item BatchNo"] || "string",
  //       kitBatchNo: item?.["Kit BatchNo"] || "string",
  //       cssdLotNo: "string",
  //       createdBy: "string",
  //       lastModifiedBy: "string",
  //       createdDate: new Date().toISOString(),
  //       lastModifiedDate: new Date().toISOString(),
  //     }));

  //     // 🔹 Call API (even if payload is empty)
  //     const response = await saveTransferCssdItemsList(payload);

  //     if (response?.status === 200) {
  //       successAlert("Items successfully sent for wrapping!");
  //       setOpenPostModal(false);

  //       // Refresh tables
  //       if (getItemType === "Item") populateItemTable();
  //       else populateKitTable();

  //       // ✅ Directly go to Wrapping page
  //       setView("Wrapping & Packaging");
  //     } else {
  //       errorAlert("Failed to send items!");
  //     }
  //   } catch (error) {
  //     console.error("Error sending items:", error);
  //     errorAlert("Something went wrong while sending items.");
  //   } finally {
  //     setOpenBackdrop(false);
  //   }
  // };




  // const addToStockList = async () => {
  //   setOpenBackdrop(true); // Show loading

  //   try {
  //     // 🔹 Get all items depending on type
  //     let itemDetailsArray =
  //       getItemType === "Item"
  //         ? cleaningItemsList || []
  //         : cleaningKitItemsList?.flatMap((kit) => kit.kitItemList) || [];

  //     // 🔹 If no items, add a default placeholder so API is not empty
  //     if (!itemDetailsArray.length) {
  //       itemDetailsArray.push({
  //         id: 0,
  //         "Item Code": 0,
  //         "Disposed Qty": 0,
  //         "Disposed Reason": null,
  //         "Cleaned Qty": 0,
  //         "Item BatchNo": "DEFAULT",
  //         "Kit BatchNo": "DEFAULT",
  //       });
  //     }


  //     // 🔹 Build payload for Wrapping
  //     const payload = itemDetailsArray.map((item) => ({
  //       id: item.id,
  //       processType: "wrapping",
  //       ot_details_id: 0,
  //       item_id: item?.["Item Code"] || 0,
  //       item_kit_id: 0,
  //       quantity: 0,
  //       transferDate: new Date().toISOString(),
  //       transferQty: 0,
  //       transferStatus: true,
  //       transferred_by: 0,
  //       issueDate: new Date().toISOString(),
  //       issueStatus: true,
  //       issueQty: 0,
  //       issued_by: 0,
  //       disposedDate: new Date().toISOString(),
  //       disposedQty: item?.["Disposed Qty"] || 0,
  //       disposed_by: 0,
  //       disposedReason: item?.["Disposed Reason"] || null,
  //       receiveDate: new Date().toISOString(),
  //       receiveQty: 0,
  //       receiveStatus: true,
  //       received_by: 0,
  //       cleaningStatus: true,
  //       decontaminationStatus: true,
  //       cleanedQty: item?.["Cleaned Qty"] || 0,
  //       cleaned_by: 0,
  //       cleaningStartDate: new Date().toISOString(),
  //       cleaningEndDate: new Date().toISOString(),
  //       wrappedQty: 0,
  //       wrappingStatus: true,
  //       wrapped_by: 0,
  //       wrapper_type_id: 0,
  //       wrapperTypeQty: 0,
  //       wrapping_method_id: 0,
  //       wrappingStartDate: new Date().toISOString(),
  //       wrappingEndDate: new Date().toISOString(),
  //       sterilizationQty: 0,
  //       sterilizationStatus: true,
  //       sterilizationStatusType: "wrapping",
  //       sterilization_start_by: 0,
  //       sterilizationStartDate: new Date().toISOString(),
  //       sterilizationEndDate: new Date().toISOString(),
  //       sterilization_end_by: 0,
  //       machine_id: 0,
  //       sterilization_type_id: 0,
  //       sterilization_method: 0,
  //       sterilizationExpiryDate: new Date().toISOString(),
  //       addToStockQty: 0,
  //       temperature: 0,
  //       pressure: 0,
  //       durationMinutes: 0,
  //       indicatorResult: "string",
  //       from_store_id: 0,
  //       to_store_id: 0,
  //       itemBatchNo: item?.["Item BatchNo"] || "DEFAULT",
  //       kitBatchNo: item?.["Kit BatchNo"] || "DEFAULT",
  //       cssdLotNo: "string",
  //       createdBy: "string",
  //       lastModifiedBy: "string",
  //       createdDate: new Date().toISOString(),
  //       lastModifiedDate: new Date().toISOString(),
  //     }));

  //     // 🔹 Call API
  //     const response = await saveTransferCssdItemsList(payload);

  //     if (response?.status === 200) {
  //       successAlert("Items successfully sent for wrapping!");
  //       setOpenPostModal(false);

  //       // 🔹 Refresh tables
  //       if (getItemType === "Item") populateItemTable();
  //       else populateKitTable();

  //       // 🔹 Navigate to Wrapping page
  //       setView("Sterilization Processing");
  //     } else {
  //       errorAlert("Failed to send items!");
  //     }
  //   } catch (error) {
  //     console.error("Error sending items:", error);
  //     errorAlert("Something went wrong while sending items.");
  //   } finally {
  //     setOpenBackdrop(false);
  //   }
  // };



  // 1️⃣ Flatten



  // const renderInputKitItem = (row, index, header) => {
  //   return (
  //     <div className="-my-2">
  //       {/* {header === "Select" && (
  //         <Checkbox
  //           size="small"
  //           name={`${values}SelectKitItem${index}`}
  //           checked={row?.Select}
  //           onChange={(e) => {
  //             setPackagingKitItemsList((prevDataObj) =>
  //               prevDataObj?.map((kit, kitInd) => ({
  //                 ...kit,
  //                 kitItemList: kit.kitItemList?.map((val) =>
  //                   values === kitInd &&
  //                   val?.["Item Code"] === row?.["Item Code"] &&
  //                   val?.["Sr No"] === row?.["Sr No"]
  //                     ? { ...val, Select: e.target.checked }
  //                     : val
  //                 ),
  //               }))
  //             );
  //           }}
  //         />
  //       )} */}
  //       {header === "Wrapped Qty" && (
  //         <input
  //           type="number"
  //           name={`${values}wrappedQty${index}`}
  //           value={row?.["Wrapped Qty"]}
  //           className="border border-black rounded w-28 px-2"
  //           onChange={(e) => {
  //             if (e.target.value <= Number(row?.["Old Wrapped Qty"])) {
  //               setPackagingKitItemsList((prevDataObj) =>
  //                 prevDataObj?.map((kit, kitInd) => ({
  //                   ...kit,
  //                   kitItemList: kit.kitItemList?.map((val) =>
  //                     values === kitInd &&
  //                       val?.["Item Code"] === row?.["Item Code"] &&
  //                       val?.["Sr No"] === row?.["Sr No"]
  //                       ? {
  //                         ...val,
  //                         "Wrapped Qty":
  //                           e.target.value !== ""
  //                             ? e.target.value
  //                             : val?.["Old Wrapped Qty"],
  //                       }
  //                       : val
  //                   ),
  //                 }))
  //               );
  //             }
  //           }}
  //           onWheel={(e) => e.target.blur()}
  //           onKeyDown={(e) =>
  //             ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
  //               e.key
  //             ) && e.preventDefault()
  //           }
  //         />
  //       )}
  //     </div>
  //   );
  // };

  // const renderInputKitItem = (row, index, header, kitIndex) => {
  //   return (
  //     <div className="-my-2">
  //       {header === "Select" && (
  //         <Checkbox
  //           size="small"
  //           name={`${values}SelectKitItem${index}`}
  //           checked={row?.Select}
  //           onChange={(e) => {
  //           }}
  //         />
  //       )}
  //       {header === "Wrapped Qty" && (
  //         <input
  //           type="number"
  //           name={`wrappedQty_${kitIndex}_${index}`}
  //           value={row?.["Wrapped Qty"]}
  //           className="border border-black rounded w-28 px-2"
  //           onChange={(e) => {
  //             const newValue = e.target.value;

  //             if (Number(newValue) <= Number(row?.["Old Wrapped Qty"])) {
  //               setPackagingKitItemsList((prev) =>
  //                 prev.map((kit, kIndex) => {
  //                   // ONLY update the selected kit
  //                   if (kIndex !== kitIndex) return kit;

  //                   return {
  //                     ...kit,
  //                     kitItemList: kit.kitItemList.map((item) =>
  //                       item["Item Code"] === row["Item Code"] &&
  //                         item["Sr No"] === row["Sr No"]
  //                         ? {
  //                           ...item,
  //                           "Wrapped Qty":
  //                             newValue !== "" ? newValue : item["Old Wrapped Qty"],
  //                         }
  //                         : item
  //                     ),
  //                   };
  //                 })
  //               );
  //             }
  //           }}
  //           onWheel={(e) => e.target.blur()}
  //           onKeyDown={(e) =>
  //             ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(e.key) &&
  //             e.preventDefault()
  //           }
  //         />
  //       )}
  //     </div>
  //   );
  // };


  const renderInputKitItem = (row, index, header) => {
    return (
      <div className="-my-2">

        {header === "Select" && (
          <Checkbox
            size="small"
            checked={row?.Select}
            onChange={() => {
              updateKitItem(row, { Select: !row?.Select });
            }}
          />
        )}

        {header === "Delete" && (
          <IconButton
            size="small"
            color="error"
            onClick={() => handleDeleteClick(row)}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}

        {/* {header === "Wrapped Qty" && (
          <input
            type="number"
            value={row?.["Wrapped Qty"]}
            className="border border-gray-400 rounded px-2 h-[28px] w-28 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
            onChange={(e) => {
              const newValue = e.target.value;
              if (Number(newValue) <= Number(row?.["Old Wrapped Qty"])) {
                updateKitItem(row, {
                  "Wrapped Qty":
                    newValue !== ""
                      ? newValue
                      : row?.["Old Wrapped Qty"],
                });
              }
            }}
          />
        )} */}

      </div>
    );
  };


  const allItems = packagingKitItemsList.flatMap(kit =>
    kit.kitItemList?.map(item => ({
      ...item,
      KitName: item.KitName,
      parentKitId: kit.id
    })) || []
  );

  // // 2️⃣ Group by real kitId
  // const groupedItems = allItems.reduce((acc, item) => {
  //   const key = item.kitId ?? 0;
  //   if (!acc[key]) acc[key] = [];
  //   acc[key].push(item);
  //   return acc;
  // }, {});


  // 3️⃣ For Tabs
  // const finalTabs = Object.entries(groupedItems).map(([kitId, items]) => ({
  //   // kitId,
  //   kitId: Number(kitId),
  //   KitName: items[0]?.KitName || `Kit ${kitId}`,
  //   items,
  // }));


  useEffect(() => {
    if (!manualUpdate && allItems?.length > 0) {
      const grouped = allItems.reduce((acc, item) => {
        const key = item.kitId ?? 0; // safe fallback
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      setGroupedItems(prev => ({
        ...prev,
        ...grouped,
      }));
    }

    setManualUpdate(false);
  }, [packagingKitItemsList, manualUpdate]);


  // console.log("allItesm321", allItems);

  // console.log("groupedItems", groupedItems);


  useEffect(() => {
    const updatedTabs = Object.entries(groupedItems).map(([kitId, items]) => ({
      kitId,
      KitName: items?.[0]?.KitName || `Kit ${kitId}`,
      items,
    }));

    setFinalTabs(updatedTabs);
  }, [groupedItems]);


  const updateKitItem = (row, changes) => {
    setPackagingKitItemsList((prev) =>
      prev.map((kit) => ({
        ...kit,
        kitItemList: kit.kitItemList.map((item) =>
          item["Item Code"] === row["Item Code"] &&
            item["Sr No"] === row["Sr No"]
            ? { ...item, ...changes }
            : item
        ),
      }))
    );
  };

  const addToStockList = async () => {
    setOpenBackdrop(true); // Show loading

    // try {
    // Get all items depending on type
    // const itemDetailsArray =
    //   getItemType === "Item"
    //     ? packagingItemList || []
    //     : packagingKitItemsList?.flatMap((kit) => kit.kitItemList) || [];

    // // If no items, add a default placeholder
    // if (!itemDetailsArray.length) {
    //   itemDetailsArray.push({
    //     id: 0,
    //     "Item Code": 0,
    //     "Disposed Qty": 0,
    //     "Disposed Reason": null,
    //     "Cleaned Qty": 0,
    //     "Item BatchNo": "DEFAULT",
    //     "Kit BatchNo": "DEFAULT",
    //   });
    // }

    try {
      const itemDetailsArray =
        getItemType === "Item"
          ? cleaningItemsList.map(item => ({
            ...item,
            kitId: item.kitId || 0,
          }))
          : finalTabs.flatMap(tab =>
            tab.items.map(item => ({
              ...item,
              kitId: Number(tab.kitId),
              KitName: tab.KitName,
            }))
          );

      if (!itemDetailsArray?.length) {
        warningAlert("No items available to send!");
        return;
      }

      //start
      // const wrappedQtyErrors = [];

      // itemDetailsArray.forEach((item, index) => {
      //   const wrappedQty = Number(item["Wrapped Qty"]);

      //   if (!wrappedQty || isNaN(wrappedQty) || wrappedQty <= 0) {
      //     wrappedQtyErrors.push(
      //       `Row ${index + 1}: Wrapped Qty must be greater than 0`
      //     );
      //   }
      // });

      // if (wrappedQtyErrors.length) {
      //   warningAlert(wrappedQtyErrors.join("\n"));
      //   setOpenBackdrop(false);
      //   return;
      // }
      //end

      const payload = itemDetailsArray.map((item) => ({
        id: item.id || 0,
        processType: "wrapping",
        ot_details_id: 0,
        item_id: item["Item Code"] || 0,
        item_kit_id: 0,
        quantity: 0,
        transferDate: new Date().toISOString(),
        transferQty: 0,
        transferStatus: true,
        transferred_by: 0,
        issueDate: new Date().toISOString(),
        issueStatus: true,
        issueQty: 0,
        issued_by: 0,
        disposedDate: new Date().toISOString(),
        disposedQty: item?.["Disposed Qty"] || 0,
        disposed_by: 0,
        disposedReason: item?.["Disposed Reason"] || null,
        receiveDate: new Date().toISOString(),
        receiveQty: 0,
        receiveStatus: true,
        received_by: 0,
        cleaningStatus: true,
        decontaminationStatus: true,
        cleanedQty: item?.["Cleaned Qty"] || 0,
        cleaned_by: 0,
        cleaningStartDate: new Date().toISOString(),
        cleaningEndDate: new Date().toISOString(),
        wrappedQty: item["Cleaned Qty"] || 0,
        wrappingStatus: true,
        wrapped_by: 0,
        wrapper_type_id: item["Wrapper Type Id"] || 0,
        wrapperTypeQty: 0,
        wrapping_method_id: item["Wrapping Method Id"] || 0,
        wrappingStartDate: new Date().toISOString(),
        wrappingEndDate: new Date().toISOString(),
        sterilizationQty: 0,
        sterilizationStatus: true,
        sterilizationStatusType: "wrapping",
        sterilization_start_by: 0,
        sterilizationStartDate: new Date().toISOString(),
        sterilizationEndDate: new Date().toISOString(),
        wrapping_method_id: selectedWrappingMethodId,
        wrapper_type_id: selectedWrapperTypeId,
        sterilization_end_by: 0,
        machine_id: 0,
        sterilization_type_id: 0,
        sterilization_method: 0,
        sterilizationExpiryDate: new Date().toISOString(),
        addToStockQty: 0,
        temperature: 0,
        pressure: 0,
        durationMinutes: 0,
        indicatorResult: "string",
        from_store_id: 0,
        to_store_id: 0,
        itemBatchNo: item?.["Item BatchNo"] || "DEFAULT",
        kitBatchNo: item?.["Kit BatchNo"] || "DEFAULT",
        cssdLotNo: "string",
        createdBy: "string",
        lastModifiedBy: "string",
        createdDate: new Date().toISOString(),
        lastModifiedDate: new Date().toISOString(),
      }));

      console.log("Payload with IDs:", payload);

      // Call API
      const response = await saveTransferCssdItemsList(payload);

      if (response?.status === 200) {
        successAlert("Items successfully sent for wrapping!");
        setOpenPostModal(false);
        if (getItemType === "Item") populateItemTable();
        else populateKitTable();
        setView("Sterilization Processing");
      } else {
        errorAlert("Failed to send items");
      }
    } catch (error) {
      console.error("Error sending items:", error);
      errorAlert("Something went wrong while sending items.");
    } finally {
      setOpenBackdrop(false);
    }
  };

  console.log("packagingItemList", packagingItemList);

  const handleItemKitChange = (autoSearchString) => {
    if (
      autoSearchString !== "" &&
      UseCheckConsecutiveCharacters(autoSearchString)
    ) {
      setSearchBarString(autoSearchString);
      autoSearchCssdItemKit(autoSearchString, "cssd")
        .then((response) => response.data)
        .then((res) => {
          setItemKitOptions(res.result);
        });
    } else if (autoSearchString === "") {
      setSearchBarString("");
      setItemKitOptions([]);
    }
  };

  const handleFromStoreChange = (inputValue) => {
    if (typeof inputValue !== "string") return;

    setSearchBarString(inputValue);

    const trimmedValue = inputValue.trim();

    if (
      trimmedValue.length > 0 &&
      UseCheckConsecutiveCharacters(trimmedValue)
    ) {
      getStoreDropdown(trimmedValue)
        .then((res) => {
          setStoreOptions(res?.data?.result ?? []);
        })
        .catch(() => {
          setStoreOptions([]);
        });
    } else {
      setStoreOptions([]);
    }
  };

  const selectedSearchBarValue = (value) => {
    if (value !== null) {
      setSearchBarId(value?.id);
      setSearchBarString("");
    } else {
      setSearchBarId(null);
    }
  };

  // useMemo(() => {
  //   if (getItemType === "Item") {
  //     populateItemTable();
  //     setPackagingKitList([]);
  //     setPackagingKitItemsList([]);
  //   } else if (getItemType === "Kit") {
  //     populateKitTable();
  //     setPackagingKitItemsList([]);
  //     setPackagingItemList([]);
  //   }
  // }, [getItemType]);

  useMemo(() => {
    populateKitTable();
    setPackagingKitItemsList([]);
    setPackagingItemList([]);
  }, [
    kitListingObject?.fromDate,
    kitListingObject?.toDate,
    kitListingObject?.searchId,
    kitListingObject?.searchString,
  ]);


  // useEffect(() => {
  //   getWrapperTypeDropdown()
  //     .then(res => {
  //       const data = Array.isArray(res?.data)
  //         ? res.data
  //         : res?.data?.data || [];   // 👈 fallback

  //       setWrapperTypeOptions(data);
  //     });

  //   getWrappingMethodDropdown()
  //     .then(res => {
  //       const data = Array.isArray(res?.data)
  //         ? res.data
  //         : res?.data?.data || [];

  //       setWrappingMethodOptions(data);
  //     });
  // }, []);

  const handleWrapperTypeChange = (autoSearchString) => {
    if (typeof autoSearchString !== "string") return;

    setSearchBarString(autoSearchString);

    const trimmedValue = autoSearchString.trim();

    if (
      trimmedValue !== "" &&
      UseCheckConsecutiveCharacters(trimmedValue)
    ) {
      getWrapperTypeDropdown(trimmedValue)
        .then((response) => response.data)
        .then((res) => {
          const data = Array.isArray(res)
            ? res
            : res?.data || res?.result || [];

          setWrapperTypeOptions(data);
        })
        .catch(() => setWrapperTypeOptions([]));
    } else if (trimmedValue === "") {
      setWrapperTypeOptions([]);
    }
  };


  const handleWrappingMethodChange = (autoSearchString) => {
    if (typeof autoSearchString !== "string") return;

    setSearchBarString(autoSearchString);

    const trimmedValue = autoSearchString.trim();

    if (
      trimmedValue !== "" &&
      UseCheckConsecutiveCharacters(trimmedValue)
    ) {
      getWrappingMethodDropdown(trimmedValue)
        .then((response) => response.data)
        .then((res) => {
          setWrappingMethodOptions(res?.result || []);
        });
    } else if (trimmedValue === "") {
      setWrappingMethodOptions([]);
    }
  };


  useEffect(() => {
    // useGetUserActions(location?.state?.menuId).then((response) => {
    //   setUserActions(response);
    // });

    // getStoreDropdown(getUserInfo?.loginUnitId).then((response) => {
    //   setStoreOptions(response.data?.result);
    // });

    // getWrapperTypeDropdown().then((response) => {
    //   setWrapperTypeOptions(response.data.result);
    // });

    // getWrappingMethodDropdown().then((response) => {
    //   setWrappingMethodOptions(response.data.result);
    // });
  }, []);

  console.log("packagingKitItemsList", packagingKitItemsList);
  console.log("packagingKitList", packagingKitList);

  console.log("finalTabs321", finalTabs);


  return (
    <div className="px-4">
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3 mt-2">
        <SearchBar
          name="searchByItem"
          placeholder="Search By Item / Kit Name"
          searchIcon={true}
          isClearable={true}
          handleInputChange={handleItemKitChange}
          dataArray={itemKitOptions}
          onChange={selectedSearchBarValue}
        />
        <div className="grid grid-cols-2 gap-2">
          <DatePickerField
            control={control}
            name="fromDate"
            label="From Date"
            inputFormat="dd-MM-yyyy"
          />
          <DatePickerField
            control={control}
            name="toDate"
            label="To Date"
            inputFormat="dd-MM-yyyy"
          />
        </div>

        <SearchDropdown
          control={control}
          name="fromStore"
          placeholder="From Store"
          dataArray={storeOptions}
          inputValue={searchBarString}
          isClearable
          handleInputChange={handleFromStoreChange}
          onChange={(selected) => {
            console.log("Selected fromStore:", selected);
          }}
        />

        <div className="flex justify-between space-x-2 lg:col-span-3  xl:col-span-1 2xl:col-span-2">
          <div className="flex space-x-2">
            <CommonButton
              type="button"
              searchIcon={true}
              className="bg-customBlue text-white"
              // onClick={() => {
              //   setKitListingObject((kitListingObject) => ({
              //     ...kitListingObject,
              //     fromDate: getFromDate
              //       ? format(getFromDate, "dd-MM-yyyy")
              //       : null,
              //     toDate: getToDate ? format(getToDate, "dd-MM-yyyy") : null,
              //     searchId: searchBarId ? searchBarId : null,
              //     searchString: searchBarString ? searchBarString : "",
              //   }));
              // }}
              onClick={handleReceiveCSSDSearch}
            />
            <CommonButton
              type="button"
              label="Reset"
              className="border border-customRed text-customRed"
              onClick={() => {
                setKitListingObject((kitListingObject) => ({
                  ...kitListingObject,
                  searchId: null,
                  searchString: "",
                  fromDate: null,
                  toDate: null,
                }));
                setValue("fromDate", null);
                setValue("toDate", null);
                setSearchBarId(null);
                setSearchBarString("");
              }}
            />
          </div>

          <div className="flex gap-1">
            <CommonButton
              type="button"
              label="Add Item"
              className="border border-customBlue text-customBlue"
              onClick={() => {
                setAddType("item");
                setOpenAddKitModal(true);
              }}
            />
          </div>
        </div>

      </div>
      <div className="grid lg:grid-cols-2 justify-between">
        <div className="flex space-x-2 items-center mt-3">
          <fieldset className="hidden">
            <RadioField
              control={control}
              name="itemType"
              dataArray={itemType}
            />
          </fieldset>
          {getItemType === "Kit" ? (
            <div className="w-80 hidden">
              <SearchDropdown
                control={control}
                searchIcon={true}
                name="itemKit"
                dataArray={itemKitOptions}
                isSearchable={true}
                placeholder="Search Item Kit"
                isClearable={true}
                handleInputChange={handleItemKitChange}
              />
            </div>
          ) : (
            <div className="w-80 hidden">
              <SearchDropdown
                control={control}
                searchIcon={true}
                name="itemKit"
                // dataArray={itemKitOptions}
                isSearchable={true}
                placeholder="Search Item Name"
                isClearable={true}
              // handleInputChange={handleItemKitChange}
              />
            </div>
          )}
          <CommonButton
            type="button"
            searchIcon={true}
            className="bg-customBlue text-white hidden"
          />
        </div>
        <div className="">
          {packagingKitItemsList?.length > 0 && (
            // <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            //   <Tabs
            //     value={values}
            //     onChange={handleChange}
            //     aria-label="basic tabs example"
            //     variant="scrollable"
            //   >
            //     {packagingKitItemsList?.map((val, ind) => (
            //       <Tab label={val?.KitName} {...a11yProps(ind)} />
            //     ))}
            //   </Tabs>
            // </Box>
            <div className="flex space-x-4 border-b border-gray-300">
              {finalTabs.map((tab, index) => (
                <button
                  key={index}
                  className={`px-3 py-1 font-semibold ${values === index
                    ? "text-customBlue border-b-2 border-customBlue"
                    : "text-gray-500"
                    }`}
                  onClick={() => setValues(index)}
                >
                  {tab.KitName || `Kit ${tab.kitId}`}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      {getItemType === "Kit" ? (
        <div className="grid xl:grid-cols-2 xl:gap-x-2">
          {packagingKitList?.length > 0 ? (
            <CommonTransactionTable
              dataResult={packagingKitList}
              page={kitPage}
              setPage={setKitPage}
              count={kitCount}
              rowsPerPage={kitRowsPerPage}
              renderInput={renderInputKit}
              populateTable={populateKitTable}
              editableColumns={[
                "Select",
                "Wrapper Type",
                // "Wrapper Type Qty",
                "Wrapping Method",
              ]}
              highlightRow={false}
              tableClass={"h-96"}
              // removeHeaders={[
              //   "Transfer Date",
              //   "Receive Date",
              //   "Transferred By",
              //   "Received By",
              //   "Ot Details Id",
              //   "Item Id",
              //   "Created Date",
              //   "Last Modified Date",
              //   "Cleaning Status",
              //   "Decontamination Status",
              //   "Sterilization Qty",
              //   "Sterilization Status",
              //   "Wrapped Qty",
              //   "Wrapping Status",
              //   "Cleaned By",
              //   "Wrapped By",
              //   "Sterilized By",
              //   "Receive Status",
              //   "Sterilization Status Type",
              //   "Transfer Status",
              //   "Sterilization End By",
              //   "Sterilization Start By",
              //   "Transferred By",
              //   "Id",
              //   "Created Date",
              //   "Created By",
              //   "Last Modified By",
              //   "Status",
              //   "Sent By",
              //   "Used Quantity",
              //   "Transfer Qty",
              //   "Item Code",
              //   "Item Name",
              //   "Cleaned Qty",
              //   "Receive Qty",
              //   "Sterilization Method Id",
              //   "Sterilization Method Name",
              //   "Sterilization Equipment Id",
              //   "Sterilization Equipment Name",
              //   "Wrapper Type Name",
              //   "Wrapper Type Id",
              //   "Wrapping Method Name",
              //   "Wrapping Method Id",
              //   "Sterilization ExpiryDate",
              //   "AddToStock Qty",
              //   "Sterilization Start Date",
              //   "Sterilization End Date",
              //   "Sterilization Equipment",
              //   "Sterilization Method",
              //   "Machine Id",
              //   "Machine Name",
              //   "Wrapping Start Date",
              //   "Wrapping End Date",
              //   "Sr No",
              //   "Cleaning Start Date",
              //   "Cleaning End Date",
              //   "Issue Date",
              //   "Issue Qty",
              //   "Issue Status",
              //   "Issued By",
              //   "Disposed Date",
              //   "Disposed Qty",
              //   "Disposed By",
              //   "Disposed Reason",
              //   "Item BatchNo",
              //   "Temperature",
              //   "Pressure",
              //   "CSSD LotNo",
              //   "Indicator Result",
              //   "Cssd Transfer Id",
              // ]}
              removeHeaders={[
                "Id",
                "createdBy",
                "Wrapper Type Qty",
                "cssdLotNo",
                "Sr No",
                "Created Date",
                "from_store_id",
                "unit_id",
                // "unit_id",
                // "from_store_id",
                "to_store_id",
                // "to_store_id",
                "discardedQuantity",
                // "discardedQuantity",
                "transitQuantity",
                // "transitQuantity",
                "lastModifiedBy",
                // "Last Modified Date",
                // "cssdLotNo",
                // "Created By",
                "ot_details_id",
                // "ot_details_id",
                "Last Modified By",
                "Item Id",
                "Item Code",
                "Item Name",
                "Ot Details Id",
                "Receive Date",
                "Status",
                "transferDate",
                // "Transfer Date",
                "Received By",
                "Sent By",
                "Cleaned Qty",
                "Cleaning Status",
                "Decontamination Status",
                "Receive Qty",
                "Sterilization Qty",
                "Sterilization Status",
                "transferQty",
                // "Transfer Qty",
                "Wrapped Qty",
                "Wrapping Status",
                "Cleaned By",
                "Wrapped By",
                "Sterilized By",
                "Receive Status",
                "Sterilization Status Type",
                "transferStatus",
                // "Transfer Status",
                "Sterilization End By",
                "Sterilization Start By",
                "transferred_by",
                // "Transferred By",
                "Used Quantity",
                "Sterilization ExpiryDate",
                "AddToStock Qty",
                "Cleaning Start Date",
                "Cleaning End Date",
                "Wrapping Start Date",
                "Wrapping End Date",
                "Sterilization Equipment Id",
                "Machine Id",
                "Machine Name",
                "Sterilization Start Date",
                "Sterilization End Date",
                "Sterilization Equipment",
                "Sterilization Method Id",
                "Sterilization Method",
                "Wrapper Type Id",
                "Wrapper Type",
                "Wrapping Method Id",
                "Wrapping Method",
                "Issue Date",
                "issuedQuantity",
                // "Issue Qty",
                "Issue Status",
                "Issued By",
                "Disposed Date",
                "Disposed Qty",
                "Disposed By",
                "Disposed Reason",
                "Item BatchNo",
                "Temperature",
                "Pressure",
                "Cssd Transfer Id",
              ]}
            />
          ) : (
            <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
              No Records Found...
            </div>
          )}
          {/* {packagingKitItemsList?.length > 0 ? (
            <div className="mt-4">
              {packagingKitItemsList?.map((kit, kitIndex) => {
                return (
                  <>
                    {values === kitIndex && (
                      <div className="">
                        <div className="flex justify-between font-semibold text-sm bg-[#F1F1F1] px-2 py-1">
                          <label className="">{kit.KitName}</label>
                          <label className="">
                            Items Qty : {kit.kitItemList?.length}
                          </label>
                        </div>
                        {kit?.kitItemList?.length > 0 ? (
                          <CommonTransactionTable
                            dataResult={kit.kitItemList}
                            tableClass={"-mt-1 h-96"}
                            renderInput={renderInputKitItem}
                            editableColumns={["Wrapped Qty"]}
                            highlightRow={false}
                            removeHeaders={[
                              "Transfer Date",
                              "Receive Date",
                              "Transferred By",
                              "Received By",
                              "Ot Details Id",
                              "Item Id",
                              "Created Date",
                              "Last Modified Date",
                              "Cleaning Status",
                              "Decontamination Status",
                              "Sterilization Qty",
                              "Sterilization Status",
                              "Wrapping Status",
                              "Cleaned By",
                              "Wrapped By",
                              "Sterilized By",
                              "Receive Status",
                              "Sterilization Status Type",
                              "Transfer Status",
                              "Sterilization End By",
                              "Sterilization Start By",
                              "Transferred By",
                              "Id",
                              "Created Date",
                              "Created By",
                              "Last Modified By",
                              "Status",
                              "Sent By",
                              "Used Quantity",
                              "Transfer Qty",
                              "Sterilization Method Id",
                              "Sterilization Method Name",
                              "Sterilization Equipment Id",
                              "Sterilization Equipment Name",
                              "Wrapper Type Name",
                              "Wrapper Type Id",
                              "Wrapping Method Name",
                              "Wrapping Method Id",
                              "Sterilization ExpiryDate",
                              "AddToStock Qty",
                              "Sterilization Start Date",
                              "Sterilization End Date",
                              "Sterilization Equipment",
                              "Sterilization Method",
                              "Machine Id",
                              "Machine Name",
                              "Wrapping Start Date",
                              "Wrapping End Date",
                              "Sr No",
                              "Item Kit Code",
                              "Cleaning Start Date",
                              "Cleaning End Date",
                              "Issue Date",
                              "Issue Qty",
                              "Issue Status",
                              "Issued By",
                              "Disposed Date",
                              "Disposed By",
                              "Item Kit Name",
                              "Old Cleaned Qty",
                              "Kit BatchNo",
                              "Receive Qty",
                              "Disposed Qty",
                              "Disposed Reason",
                              "Select",
                              "Temperature",
                              "Pressure",
                              "CSSD LotNo",
                              "Wrapper Type Qty",
                              "Indicator Result",
                              "Cssd Transfer Id",
                              "Old Wrapped Qty",
                            ]}
                          />
                        ) : (
                          <div className="w-full h-60 flex justify-center items-center font-semibold border border-gray-300 rounded">
                            No items found against kit...!
                          </div>
                        )}
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          ) : (
            <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
              No Records Found...
            </div>
          )} */}

          {finalTabs?.length > 0 ? (
            <div className="mt-1 p-0">
              {finalTabs.map((kit, index) =>
                index === values ? (
                  <div key={index} className="mt-1 p-0">

                    <div className="bg-[#F1F1F1] px-2 py-2">
                      <div className="flex items-center text-sm font-semibold whitespace-nowrap">

                        <div className="flex-1 max-w-[200px] truncate">
                          {kit.KitName}
                        </div>

                        <div className="flex flex-1 justify-center items-center gap-4">

                          {/* <div className="flex items-center gap-1">
                            <span>Wrapper Type</span>
                            <Autocomplete
                              freeSolo
                              size="small"
                              disableClearable
                              options={wrapperTypeOptions}
                              getOptionLabel={(opt) =>
                                typeof opt === "string" ? opt : opt?.label || ""
                              }

                              value={wrapperTypeInput}
                              onInputChange={(e, v) => setWrapperTypeInput(v)}

                              onChange={(e, v) => {
                                const value = typeof v === "string" ? v : v?.label || "";

                                // ✅ update table
                                setPackagingKitItemsList(prev =>
                                  prev.map(parent => ({
                                    ...parent,
                                    kitItemList: parent.kitItemList.map(item =>
                                      item.kitId === kit.kitId
                                        ? { ...item, "Wrapper Type": value }
                                        : item
                                    ),
                                  }))
                                );

                                // ✅ CLEAR DROPDOWN
                                setWrapperTypeInput("");
                              }}

                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Search"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {params.InputProps.endAdornment}
                                        <InputAdornment position="end">
                                          <SearchIcon fontSize="small" />
                                        </InputAdornment>
                                      </>
                                    ),
                                  }}
                                  sx={{
                                    width: 150,
                                    "& .MuiInputBase-root": { height: 28 },
                                    "& .MuiInputBase-input": {
                                      padding: "2px 6px",
                                      fontSize: "0.8rem",
                                    },
                                  }}
                                />
                              )}
                            />

                          </div> */}

                          <div className="flex items-center gap-1">
                            <span>Wrapper Type</span>

                            <Autocomplete
                              freeSolo
                              size="small"
                              disableClearable
                              popupIcon={null}
                              options={Array.isArray(wrapperTypeOptions) ? wrapperTypeOptions : []}

                              getOptionLabel={(opt) => opt?.label || ""}
                              isOptionEqualToValue={(opt, val) => opt?.id === val?.id}

                              onInputChange={(e, value) => {
                                handleWrapperTypeChange(value);
                              }}

                              onChange={(e, v) => {
                                if (!v) return;

                                // ✅ STORE ID
                                setSelectedWrapperTypeId(v.id);

                                // ✅ UPDATE TABLE
                                setPackagingKitItemsList((prev) =>
                                  prev.map((parent) => ({
                                    ...parent,
                                    kitItemList: parent.kitItemList.map((item) =>
                                      item.kitId == kit.kitId
                                        ? {
                                          ...item,
                                          "Wrapper Type": v.label,
                                          wrapper_type_id: v.id,
                                        }
                                        : item
                                    ),
                                  }))
                                );
                              }}

                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Search"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (              // ✅ SEARCH ICON RIGHT
                                      <InputAdornment position="end">
                                        <SearchIcon fontSize="small" />
                                      </InputAdornment>
                                    ),
                                  }}
                                  sx={{
                                    width: 150,
                                    "& .MuiInputBase-root": { height: 28 },
                                    "& .MuiInputBase-input": {
                                      padding: "2px 6px",
                                      fontSize: "0.8rem",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>

                          {/* <div className="flex items-center gap-1">
                            <span>Wrapping Method</span>

                            <Autocomplete
                              freeSolo
                              size="small"
                              disableClearable
                              options={Array.isArray(wrappingMethodOptions) ? wrappingMethodOptions : []}
                              getOptionLabel={(opt) =>
                                typeof opt === "string" ? opt : opt?.label || ""
                              }

                              value={selectedWrappingMethod}
                              onInputChange={(e, v) => setSelectedWrappingMethod(v)}

                              onChange={(e, v) => {
                                const value = typeof v === "string" ? v : v?.label || "";

                                setPackagingKitItemsList(prev =>
                                  prev.map(parent => ({
                                    ...parent,
                                    kitItemList: parent.kitItemList.map(item =>
                                      item.kitId == kit.kitId
                                        ? { ...item, "Wrapping Method": value }
                                        : item
                                    ),
                                  }))
                                );

                                setSelectedWrappingMethod("");
                              }}

                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Search"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <SearchIcon fontSize="small" />
                                      </InputAdornment>
                                    ),
                                  }}
                                  sx={{
                                    width: 150,
                                    "& .MuiInputBase-root": { height: 28 },
                                    "& .MuiInputBase-input": {
                                      padding: "2px 6px",
                                      fontSize: "0.8rem",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div> */}

                          <div className="flex items-center gap-1">
                            <span>Wrapping Method</span>

                            <Autocomplete
                              freeSolo
                              size="small"
                              disableClearable
                              options={Array.isArray(wrappingMethodOptions) ? wrappingMethodOptions : []}

                              getOptionLabel={(opt) => opt?.label || ""}

                              isOptionEqualToValue={(opt, val) => opt?.id === val?.id}

                              onInputChange={(e, value) => {
                                handleWrappingMethodChange(value);
                              }}


                              onChange={(e, v) => {
                                if (!v) return;

                                // ✅ STORE ID (for payload)
                                setSelectedWrappingMethodId(v.id);

                                // ✅ UPDATE KIT ITEMS
                                setPackagingKitItemsList((prev) =>
                                  prev.map((parent) => ({
                                    ...parent,
                                    kitItemList: parent.kitItemList.map((item) =>
                                      item.kitId == kit.kitId
                                        ? {
                                          ...item,
                                          "Wrapping Method": v.label,      // for UI
                                          wrapping_method_id: v.id         // for API
                                        }
                                        : item
                                    ),
                                  }))
                                );
                              }}

                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Search"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <SearchIcon fontSize="small" />
                                      </InputAdornment>
                                    ),
                                  }}
                                  sx={{
                                    width: 150,
                                    "& .MuiInputBase-root": { height: 28 },
                                    "& .MuiInputBase-input": {
                                      padding: "2px 6px",
                                      fontSize: "0.8rem",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>

                        </div>

                        <div className="flex-1 text-right">
                          Items Qty : {kit.items?.length}
                        </div>

                      </div>
                    </div>

                    {kit?.items?.length > 0 ? (
                      <CommonTransactionTable
                        dataResult={kit.items}
                        tableClass="-mt-1 h-96"
                        renderInput={renderInputKitItem}
                        editableColumns={[
                          "Select",
                          "Delete",
                        ]}
                        highlightRow={false}
                        removeHeaders={[
                          // "id",
                          "id",
                          "kitId",
                          // "kitId",
                          "Transfer Date",
                          "Receive Date",
                          "Transferred By",
                          "Received By",
                          "Ot Details Id",
                          "Item Id",
                          "Created Date",
                          "Last Modified Date",
                          "Cleaning Status",
                          "Decontamination Status",
                          "Sterilization Qty",
                          "Sterilization Status",
                          "Wrapping Status",
                          "Cleaned By",
                          "Wrapped By",
                          "Sterilized By",
                          "Receive Status",
                          "Sterilization Status Type",
                          "Transfer Status",
                          "Sterilization End By",
                          "Sterilization Start By",
                          "Transferred By",
                          "Id",
                          "Created Date",
                          "Created By",
                          "Last Modified By",
                          "Status",
                          "Sent By",
                          "Used Quantity",
                          "Transfer Qty",
                          "Sterilization Method Id",
                          "Sterilization Method Name",
                          "Sterilization Equipment Id",
                          "Sterilization Equipment Name",
                          "Wrapper Type Name",
                          // "wrapper_type_id",
                          //  "wrapping_method_id",
                          "wrapper_type_id",
                          "wrapping_method_id",
                          // "Wrapper Type Id",
                          "Wrapping Method Name",
                          // "Wrapping Method Id",
                          "Sterilization ExpiryDate",
                          "AddToStock Qty",
                          "Sterilization Start Date",
                          "Sterilization End Date",
                          "Sterilization Equipment",
                          "Sterilization Method",
                          "Machine Id",
                          "Machine Name",
                          "Wrapping Start Date",
                          "Wrapping End Date",
                          "Sr No",
                          "Item Kit Code",
                          "Cleaning Start Date",
                          "Cleaning End Date",
                          "Issue Date",
                          "Issue Qty",
                          "Issue Status",
                          "Issued By",
                          "Disposed Date",
                          "Disposed By",
                          "Item Kit Name",
                          "Old Cleaned Qty",
                          "Kit BatchNo",
                          "Receive Qty",
                          "Disposed Qty",
                          "Disposed Reason",
                          // "Select",
                          "Temperature",
                          "Pressure",
                          "CSSD LotNo",
                          "Wrapper Type Qty",
                          "Indicator Result",
                          "Cssd Transfer Id",
                          "Old Wrapped Qty",
                        ]}
                      />
                    ) : (
                      <div className="w-full h-60 flex justify-center items-center font-semibold border border-gray-300 rounded">
                        No items found against kit...!
                      </div>
                    )}

                  </div>
                ) : null
              )}
            </div>
          ) : (
            <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
              No Records Found...
            </div>
          )}

        </div>
      ) : (
        <div>
          {packagingItemList?.length > 0 ? (
            <CommonTransactionPaginationTable
              dataResult={packagingItemList}
              page={page}
              setPage={setPage}
              count={count}
              rowsPerPage={rowsPerPage}
              tableHeading={"Item List"}
              renderInput={renderInputItem}
              populateTable={populateItemTable}
              editableColumns={[
                "Select",
                "Wrapped Qty",
                "Wrapper Type",
                "Wrapper Type Qty",
                "Wrapping Method",
              ]}
              highlightRow={false}
              removeHeaders={[
                "Transfer Date",
                "Receive Date",
                "Transferred By",
                "Received By",
                "Ot Details Id",
                "Item Id",
                "Created Date",
                "Last Modified Date",
                "Cleaning Status",
                "Decontamination Status",
                "Sterilization Qty",
                "Sterilization Status",
                "Wrapping Status",
                "Cleaned By",
                "Wrapped By",
                "Sterilized By",
                "Receive Status",
                "Sterilization Status Type",
                "Transfer Status",
                "Sterilization End By",
                "Sterilization Start By",
                "Transferred By",
                "Id",
                "Created Date",
                "Created By",
                "Last Modified By",
                "Status",
                "Sent By",
                "Used Quantity",
                "Transfer Qty",
                "Sterilization Method Id",
                "Sterilization Method Name",
                "Sterilization Equipment Id",
                "Sterilization Equipment Name",
                "Wrapper Type Name",
                "Wrapper Type Id",
                "Wrapping Method Name",
                "Wrapping Method Id",
                "Sterilization ExpiryDate",
                "AddToStock Qty",
                "Sterilization Start Date",
                "Sterilization End Date",
                "Sterilization Equipment",
                "Sterilization Method",
                "Machine Id",
                "Machine Name",
                "Wrapping Start Date",
                "Wrapping End Date",
                "Sr No",
                "Item Kit Code",
                "Cleaning Start Date",
                "Cleaning End Date",
                "Issue Date",
                "Issue Qty",
                "Issue Status",
                "Issued By",
                "Disposed Date",
                "Disposed By",
                "Item Kit Name",
                "Old Cleaned Qty",
                "Kit BatchNo",
                "Receive Qty",
                "Disposed Qty",
                "Disposed Reason",
                "Temperature",
                "Pressure",
                "CSSD LotNo",
                "Indicator Result",
                "Cssd Transfer Id",
                "Old Wrapped Qty",
              ]}
            />
          ) : (
            <div className="my-2 w-full h-60 flex justify-center items-center font-semibold border border-gray-300 rounded">
              No Records Found...
            </div>
          )}
        </div>
      )}
      <div className="flex justify-end">
        <CommonButton
          type="button"
          label={"Send To Sterilization"}
          className="bg-customGreen text-white"
          onClick={() => {
            let itemDetailsArray =
              getItemType === "Item"
                ? packagingItemList?.filter((fil) => fil.Select === true)
                : packagingKitItemsList?.flatMap((val) => val?.kitItemList);
            // ?.filter((fil) => fil.Select === true);
            if (itemDetailsArray?.length > 0) {
              setOpenPostModal(true);
            } else if (itemDetailsArray?.length === 0) {
              warningAlert("Select items for packaging...!");
            }
          }}
        />
      </div>


      <Dialog
        open={openModel}
        onClose={() => handleCancelDelete()}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirmation</DialogTitle>

        <DialogContent>
          Are you sure you want to delete this item?
        </DialogContent>

        <DialogActions>
          <Button color="error" variant="outlined" onClick={handleCancelDelete}>
            Cancel
          </Button>

          <Button type="button" color="success" variant="contained" onClick={handleConfirmDelete}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>


      {openKitModal && (
        <Modal open={openKitModal}>
          <Box sx={ModalStyle} className="w-[50%] h-[50%] space-y-4">

            <div className="flex justify-between">
              <label className="font-semibold">
                {addType === "kit" ? "Add New Kit" : "Add New Item"}
              </label>

              <button
                type="button"
                onClick={() => {
                  setOpenAddKitModal(false);
                  setValue("addKitItemSearch", null);
                  setSelectedKit(null);
                }}
              >
                <CloseModalIcon />
              </button>
            </div>


            <div className="flex space-x-2">

              {addType === "item" && (
                <SearchDropdown
                  control={control}
                  name="selectKitDropdown"
                  placeholder="Select Kit (Tab)"
                  dataArray={Object.entries(groupedItems).map(([kitId, items]) => ({
                    id: kitId,
                    label: items?.[0]?.KitName || `Kit ${kitId}`,
                  }))}
                  isSearchable
                  isClearable={false}
                  menuPlacement="bottom"

                  handleInputChange={(selected) => {
                    setSelectedKit(selected?.id);

                    const index = finalTabs.findIndex(tab =>
                      String(tab.kitId) === String(selected?.id)
                    );
                    if (index !== -1) setValues(index);
                  }}
                />
              )}

              <div className="w-80">
                <SearchDropdown
                  control={control}
                  searchIcon={true}
                  name="addKitItemSearch"
                  dataArray={addType === "kit" ? modalItemKitOptions : modalItemItemOptions}
                  isSearchable={true}
                  placeholder={addType === "kit" ? "Search Item Kit" : "Search Item"}
                  isClearable={true}
                  handleInputChange={handleAddKitItemChange}
                  menuPlacement="bottom"
                  inputRef={{
                    ...register("addKitItemSearch", {
                      onChange: (e) => {
                        if (addType === "kit") {
                          if (e.target.value?.batchno === null) {
                            getBatchWiseCssdKits(
                              getUserInfo?.loginUnitId,
                              e.target.value?.id
                            ).then((response) => {
                              setNewKitBatch(response?.data?.result[0]?.kitbatchno);
                              setExistKitBatch("");
                            });
                          } else {
                            setExistKitBatch(e?.target?.value?.batchno);
                            setNewKitBatch("");
                          }
                        }
                      },
                    }),
                  }}
                />
              </div>

              <CommonButton
                type="button"
                label="Add"
                className="border border-customBlue text-customBlue"
                onClick={() => {

                  // ---------- ADD KIT ----------
                  if (addType === "kit") {

                    const kitBatch = newKitBatch || existKitBatch || `KIT-${Date.now()}`;
                    const selectedItem = watch("addKitItemSearch") || {
                      id: `KIT-${Date.now()}`,
                      label: "New Kit",
                    };

                    setPackagingKitList(prev => [
                      ...prev,
                      {
                        Select: false,
                        "Item Kit Code": selectedItem.id,
                        "Item Kit Name": selectedItem.label,
                        "Kit BatchNo": kitBatch,
                        newBatch: true,
                        "Sr No": kitBatch,
                      }
                    ]);

                    reset({ addKitItemSearch: null, selectKitDropdown: null });
                    setSelectedKit(null);   // <-- clear dropdown state
                    setOpenAddKitModal(false);

                    return;
                  }

                  // ---------- ADD ITEM ----------
                  // if (addType === "item") {

                  //   const selectedItem = watch("addKitItemSearch");
                  //   const selectedDropdownKit = watch("selectKitDropdown");

                  //   if (!selectedItem?.id) return;
                  //   if (!selectedDropdownKit?.id) return;

                  //   const kitId = selectedDropdownKit.id;

                  //   const exists = groupedItems[kitId]?.some(
                  //     itm => String(itm["Item Code"]) === String(selectedItem.id)
                  //   );
                  //   if (exists) return;

                  //   setGroupedItems(prev => ({
                  //     ...prev,
                  //     [kitId]: [
                  //       ...(prev[kitId] || []),
                  //       {
                  //         Select: true,
                  //         kitId,
                  //         "Item Code": selectedItem.id,
                  //         "Item Name": selectedItem.label,
                  //         "Cleaned Qty": 1,
                  //         "Disposed Qty": 0,
                  //         "Disposed Reason": "",
                  //       }
                  //     ]
                  //   }));

                  //   const newIndex = finalTabs.findIndex(t => String(t.kitId) === String(kitId));
                  //   if (newIndex !== -1) setValues(newIndex);

                  //   // CLEAR ALL FIELDS + FORCE DROPDOWN RESET
                  //   reset({ addKitItemSearch: null, selectKitDropdown: null });
                  //   setSelectedKit(null);
                  //   setValue("addKitItemSearch", null);
                  //   setValue("selectKitDropdown", null);

                  //   // close popup
                  //   setOpenAddKitModal(false);

                  //   // Optional: focus back input next time
                  //   setTimeout(() => {
                  //     document.querySelector("input[name='addKitItemSearch']")?.focus();
                  //   }, 200);
                  // }
                  if (addType === "item") {
                    const selectedItem = watch("addKitItemSearch");
                    const selectedDropdownKit = watch("selectKitDropdown");

                    if (!selectedItem?.id) return;
                    if (!selectedDropdownKit?.id) return;

                    const kitId = selectedDropdownKit.id;

                    // ✅ GET KIT NAME FROM TABS / GROUPED DATA
                    const kitName =
                      finalTabs.find(t => String(t.kitId) === String(kitId))?.KitName ||
                      groupedItems[kitId]?.[0]?.KitName ||
                      selectedDropdownKit.label || "";

                    const exists = groupedItems[kitId]?.some(
                      itm => String(itm["Item Code"]) === String(selectedItem.id)
                    );
                    if (exists) return;

                    // ✅ ADD ITEM WITH KitName
                    setGroupedItems(prev => ({
                      ...prev,
                      [kitId]: [
                        ...(prev[kitId] || []),
                        {
                          Select: true,
                          id: null,
                          kitId,
                          KitName: kitName,          // 🔥 ADDED
                          "Item Code": selectedItem.id,
                          "Item Name": selectedItem.label,
                          "Cleaned Qty": 1,
                          "Disposed Qty": 0,
                          "Disposed Reason": "",
                        }
                      ]
                    }));

                    setPackagingKitItemsList(prev =>
                      prev.map(kit =>
                        String(kit.id) === String(kitId)
                          ? {
                            ...kit,
                            kitItemList: [
                              ...(kit.kitItemList || []),
                              {
                                Select: true,
                                id: null,
                                kitId,
                                KitName: kitName,
                                "Item Code": selectedItem.id,
                                "Item Name": selectedItem.label,
                                "Cleaned Qty": 1,
                                "Disposed Qty": 0,
                                "Disposed Reason": "",
                              }
                            ]
                          }
                          : kit
                      )
                    );

                    // 🔄 Switch to that kit tab
                    const newIndex = finalTabs.findIndex(
                      t => String(t.kitId) === String(kitId)
                    );
                    if (newIndex !== -1) setValues(newIndex);

                    // 🧹 RESET
                    reset({ addKitItemSearch: null, selectKitDropdown: null });
                    setSelectedKit(null);
                    setOpenAddKitModal(false);
                  }
                }}
              />

            </div>
          </Box>
        </Modal>
      )}

      <CommonBackDrop openBackdrop={openBackdrop} />
      <ConfirmationModal
        confirmationOpen={openPostModal}
        confirmationHandleClose={() => setOpenPostModal(false)}
        confirmationSubmitFunc={addToStockList}
        confirmationLabel="Confirmation "
        confirmationMsg={"Are you sure want to send to wrapping CSSD items ?"}
        confirmationButtonMsg="Confirm"
      />
    </div>
  );
};

export default WrappingAndPackaging;